export const presetKeyParam = 'presetKey';
export const isComponentRedirectionParam = 'isComponentRedirect';
